// extracted by mini-css-extract-plugin
export var dropdownButton = "_3v-0";
export var fullWidthDropdownButton = "_3v-1";
export var icon = "_3v-3";
export var iconPlaceholder = "_3v-2";
export var menuItemRow = "_3v-5";
export var shortcutContainer = "_3v-4";